import {Component, EventEmitter, Injector, Input, OnChanges, OnInit, Output, SimpleChanges} from '@angular/core';
import {CupomService} from '../../../core/services/cupom.service';
import {PropostaService} from '../../../core/services/proposta.service';
import {Router} from '@angular/router';
import {CepService} from '../../../core/services/cep.service';
import {ToastrService} from 'ngx-toastr';
import {CategoriaPlanoService} from '../../../core/services/categoria_plano.service';
import {AppComponent} from '../../../app.component';
import {Meta, Title} from '@angular/platform-browser';
import {Proposta} from '../../../core/viewModel/proposta.model';
import {PropostaComponent} from '../proposta';
import {DeviceDetectorService} from 'ngx-device-detector';

interface IStartPromotionDate {
    day: number;
    hour?: number;
    year?: number;
    month: number;
    minute?: number;
    second?: number;
}
interface IStartPromotion {
    cupom: string;
    hasCustomRule?: boolean;
    overValueDays?: number;
}
@Component({
    selector: 'app-resumo',
    templateUrl: './resumo.component.html',
    styleUrls: ['./resumo.component.sass']
})
export class ResumoComponent extends PropostaComponent implements OnInit, OnChanges {
    @Input() result: Proposta;
    @Input() totalDiarias: number;
    @Output() carrinhosChange = new EventEmitter();

    public activePromotion = false;
    public activeCupom: string;
    public hasCustomRule = false;
    public overValueDays = 0;

    public beginDate: IStartPromotionDate = {
        day: new Date().getDate(),
        hour: 23,
        year: new Date().getFullYear(),
        month: new Date().getMonth(),
        minute: 59,
        second: 59
    };

    public endDate: IStartPromotionDate = {
        day: new Date().getDate() + 1,
        hour: 23,
        year: new Date().getFullYear(),
        month: new Date().getMonth(),
        minute: 59,
        second: 59
    }
    constructor(
        protected injector: Injector,
        public cupomService: CupomService,
        public propostaService: PropostaService,
        public router: Router,
        public cepService: CepService,
        public toast: ToastrService,
        public categoriaPlanoService: CategoriaPlanoService,
        public appComponent: AppComponent,
        public titleService: Title,
        public meta: Meta,
        public deviceService: DeviceDetectorService,
    ) {
        super(injector);
    }

    async ngOnInit() {
        await this.inOnInit();
        this.beginDate.day = 1;
        this.endDate.year = this.beginDate.year + 50;
        await this.startPromotion('CONSUMIDOR8OFF');
    }

    transformDate(date :IStartPromotionDate) {
        return new Date(date.year, date.month, date.day, date.hour, date.minute, date.second);
    }

    async startPromotion (cupom: string, hasCustomRule?: boolean, overValueDays?: number) {
        const beginDate = this.transformDate(this.beginDate);
        const endDate = this.transformDate(this.endDate);
        const today = new Date();
        if(today >= beginDate && today <= endDate) {
            this.activePromotion = true;
            this.activeCupom = cupom;
            this.hasCustomRule = hasCustomRule;
            this.overValueDays = overValueDays;
            await this.initCupom(this.activeCupom);
        }
    }

    quarto(quarto: number) {
        if (quarto > 1) {
            return 'quartos';
        }
        return 'quarto';
    }

    valorMensalidade(result) {
        const { valorMensalidadeDesconto, valorMensalidade} = result;
        let valorDesconto = valorMensalidadeDesconto;
        if (this.isCupomValido) {
                valorDesconto = this.calcularDesconto(valorMensalidade);
                valorDesconto = this.transformMoney(valorDesconto);
            }
        return {mensalidade: valorMensalidade.toString(), mensalidadeDesconto: valorDesconto.toString()};
    }

    async initCupom(cupom: string = '') {
        this.cupom = cupom;
        await this.validaCupom();
        this.carrinhosChange.emit(this.carrinhos);
    }

    async onValidaCupom(hasCustomRule?: boolean, overValueDays?: number) {
        await this.validaCupom(hasCustomRule, overValueDays);
        this.carrinhosChange.emit(this.carrinhos);
    }

    async onLimpaCupom() {
        await this.limpaCupom();
        this.carrinhosChange.emit(this.carrinhos);
    }

    async validatePromotionCoupon(totalDiarias: number = 0, minDailyCupom: number = 0) {
        if (this.activePromotion && this.hasCustomRule) {
            await this.validatePromotionRule(totalDiarias, minDailyCupom);
        }
    }

    async validatePromotionRule(totalDiarias: number = 0, minDailyCupom: number = 0) {
        if (totalDiarias < minDailyCupom) {
            this.cupom = 'BLACKTRAVEL15';
            await this.onValidaCupom(this.hasCustomRule, this.overValueDays);
            return;
        }
        if (minDailyCupom > 0) {
            this.cupom = 'BLACKTRAVEL15';
            await this.onValidaCupom(this.hasCustomRule, this.overValueDays);
            return;
        }
    }

    async ngOnChanges(changes: SimpleChanges) {
        if (changes.hasOwnProperty('totalDiarias')) {
            if (!changes.totalDiarias.firstChange) {
                await this.validatePromotionCoupon(changes.totalDiarias.currentValue, this.minDailyCoupon);
            }
        }
    }
}
